








import {
    computed,
    defineComponent,
} from '@vue/composition-api';
import { SeoCopyBlock } from '@superbet-group/web.lib.ui-components';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import { NavigationDataStore } from '@store/modules/navigation';

export default defineComponent({
    name: 'SeoCopyBlockWrapper',
    setup() {
        const navigationModule = useVuexStore<NavigationDataStore>('navigation');
        const seoCopy = computed(() => navigationModule.getter('routeSeoData').value?.seoCopy);

        return {
            seoCopy,
        };
    },
    components: {
        SeoCopyBlock,
    },
});
